import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIM_REJECT } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { noApproveClaim } from '../../../../resources/payload';

export const useNoApproveClaim = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const payload = noApproveClaim(value);
      const response = await POST(POST_CLAIM_REJECT(), payload);
      return response;
    },
    onSuccess: (response) => {
      openAlert({ type: 'success', message: response?.message, model: 'message' });
      setTimeout(() => {
        navigateTo({ pathname: ROUTES_PATH.ROUTE_CLIAM_LIST.PATH });
      }, 1000);
    },
  });
  return { mutate, loading: isPending };
};
